import { DefaultTheme } from 'styled-components';

const treams: DefaultTheme = {
	colors: {
		primaryLight: '#e6e5f6',
		primary: '#4840BE',
		primaryDark: '#3A339F',
		secondary: '#463fbf',

		antracite: '#202428',
		slateBlue: '#6C7680',

		blue: '#0083F9',

		lightBlueDark: '#C2CAD2',
		lightBlue: '#D8E0E8',
		lightBlueLight: '#F1F3F5',

		whiteBlue: '#F6F8FA',
		whiteBlueLight: '#FAFBFB',
		white: '#FFFFFF',

		whiteTransparent: 'rgba(255, 255, 255, 0.7)',
		WhiteTransparantHard: 'rgba(255, 255, 255, 0.8)',
		WhiteTransparantMediumHard: 'rgba(255, 255, 255, 0.65)',
		WhiteTransparantMedium: 'rgba(255, 255, 255, 0.5)',
		WhiteTransparantMediumSoft: 'rgba(255, 255, 255, 0.35)',
		WhiteTransparantSoft: 'rgba(255, 255, 255, 0.2)',

		black: '#000000',

		danger: '#E92E36',
		dangerDark: '#D12930',
		green: '#6DD400',
		greenDark: '#58AC00',

		yellow: '#F7B500',
		purple: '#4840BE',

		red: '#E02020',
		transparent: 'transparent',

		employee: '#32C5FF',
		manager: '#F7B500',
	},
	images: {
		loginBackground: '/images/treams-login.png',
		logo: '/images/treams_logo.svg',
		lineGradient: 'linear-gradient(90deg, #9906B7 0%, #4840BE 100%)',
	},

	fontFamilies: {
		paragraph: 'Source Sans Pro, sans-serif',
		heading: 'Poppins, sans-serif',
	},
};

export const placeholderTheme = {
	...treams,
	colors: {
		...treams.colors,
		primaryLight: treams.colors.lightBlueDark,
		primary: treams.colors.lightBlueDark,
		primaryDark: treams.colors.lightBlueDark,
		secondary: treams.colors.lightBlueDark,
	},
	images: {
		...treams.images,
		logo: undefined,
		lineGradient: `linear-gradient(90deg, ${treams.colors.lightBlueDark} 0%, ${treams.colors.lightBlueDark} 100%);`,
	},
};

export const treamsTheme = treams;

// Backwards compatbility for old UI
export default treams;
